import styled from 'styled-components'

export const SubtitleText = styled.span`
  text-transform: uppercase;
`

export const WinText = styled.span`
  text-transform: uppercase;
`

export const SubtitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`
